import * as React from 'react';
import {render} from 'react-dom';
import App from './App';
import Confirmation from './Confirmation';
import './index.css';
const root = document.getElementById('root') as HTMLElement;
const detail = document.getElementById('detail') as HTMLElement;
const jsonNode = document.getElementById('data') as HTMLElement;
const authNode = document.getElementById('authenticity_token') as HTMLInputElement;
const idNode = document.getElementById('id') as HTMLInputElement;

if (root) {
  let data: any = {};
  if (jsonNode) {
    const jsonText = jsonNode.textContent || '{}';
    data = JSON.parse(jsonText);
  }
  render(
    <App error={data.error} phone={data.phone_no} authToken={authNode.value} id={idNode.value} />,
    root
  );
}

if (detail) {
  let data: any = {};
  if (jsonNode) {
    const jsonText = jsonNode.textContent || '{}';
    data = JSON.parse(jsonText);
  }
  render(
    <Confirmation restaurant={data.restaurant} reservation={data.reservation} authToken={authNode.value} id={idNode.value} phone={data.phone_no}/>,
    detail
  );
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx